module.exports = __webpack_public_path__ + "static/chrome-a0e7024f6c05eb176dba80cdefca9b50.png";